export const SIMILARITY_THRESHOLD = 0.9;

const toWords = (s: string) => s.toLowerCase().match(/[a-z]+/g) || [];

const toWordBigrams = (words: string[]) =>
  words.slice(0, -1).map((w, i) => `${w}\0${words[i + 1]}`);

/**
 * NLP precision
 * Formula: intersection(userBigrams, sourceBigrams) / userBigrams.length
 * - Keeping half the source verbatim → ~100%
 * - Completely rewritten text → near 0%
 */
export const computeBigramSimilarity = (
  userText: string,
  sourceText: string,
): number => {
  if (!userText || !sourceText) return 0;
  const userBigrams = toWordBigrams(toWords(userText));
  const sourceBigrams = toWordBigrams(toWords(sourceText));
  if (userBigrams.length === 0 && sourceBigrams.length === 0) return 1;
  if (userBigrams.length === 0) return 0;
  const sourceSet = new Set(sourceBigrams);
  const intersection = userBigrams.filter((bg) => sourceSet.has(bg)).length;
  return intersection / userBigrams.length;
};
